import Flickity from 'flickity'
import { set, unset } from 'utils/general'

export default el => {
  const selectors = {
    slider: '.js-hero-slider',
    slide: '.js-hero-slide'
  }

  const slides = [...el.querySelectorAll(selectors.slide)]

  let prevSlideIndex = 0

  const handleAnimation = (eventName, slider, index) => {
    const prevSlide = slider.cells[prevSlideIndex].element
    const currentSlide = slider.cells[index].element
    const prevButton = slider.prevButton.element
    const nextButton = slider.nextButton.element
    const slideZIndex = eventName === 'change' ? 1 : 0
    const navZIndex = eventName === 'change' ? 2 : 1

    currentSlide.style.zIndex = slideZIndex
    prevButton.style.zIndex = navZIndex
    nextButton.style.zIndex = navZIndex

    if (eventName === 'change') {
      set(prevSlide, 'animate-out')
    } else {
      unset(prevSlide, 'animate-out')

      prevSlideIndex = index
    }
  }

  if (slides.length > 1) {
    const heroSlider = new Flickity(selectors.slider, {
      pageDots: false,
      contain: true,
      prevNextButtons: true,
      wrapAround: true,
      autoPlay: heroInterval === 'false' ? false : parseInt(heroInterval),
      on: {
        change: function (index) {
          handleAnimation('change', this, index)
        },
        settle: function (index) {
          handleAnimation('settle', this, index)
        }
      }
    })
  }
}
